export const FACTURACION_CONTENT = {
    lessons: {
        // facturacion.como-factura — «Cómo factura el sistema: A, B, C, el CAE y qué pasa si ARCA no responde» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: null — práctica: no
        "facturacion.como-factura": {
            summary: "Qué comprobante sale de cada cobro y por qué: cuándo se factura solo y cuándo a pedido del socio, cuándo corresponde A, B o C, qué es el CAE y qué pasa si ARCA no responde en el momento de cobrar. La idea central: la facturación nunca frena un cobro, y un comprobante con CAE no se toca, se corrige con una nota de crédito.",
            keyPoints: [
                "Lo que se paga por medio electrónico (posnet, débito automático, transferencia, Mercado Pago, pago desde la app) se factura solo apenas se confirma el cobro. El efectivo se factura sólo si el socio la pide: en el acto con «Emitir comprobante», o después desde Comprobantes o desde la app.",
                "La B es la de todos los días, para los socios (consumidor final). La A es para quien tiene CUIT y la pide, y siempre para SportClub y Wellhub. La C la emite sólo un emisor monotributista; un Responsable Inscripto emite A y B.",
                "El CAE es la autorización de ARCA: sin CAE la factura no existe para ARCA. Con CAE sale el PDF con QR por mail y el socio lo ve en la app, en Mis comprobantes.",
                "Si ARCA no responde, el cobro se registra igual y la caja cierra igual: la factura queda «Pendiente de CAE» y se reintenta sola. Si figura «Falló», agotó los reintentos y la mira Administración.",
                "Una factura con CAE no se borra ni se edita: se corrige con una nota de crédito. Una A sin CUIT válido no sale, y una B que supera el tope de consumidor final pide confirmar el DNI del socio, que se toma de la ficha.",
                "Cuota y bebida son dos operaciones y dos comprobantes (Cobrar y kiosko), y cada factura sale del punto de venta de la sede donde se cobró.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // facturacion.comprobantes — «Comprobantes y notas de crédito» — roles: admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "contable.comprobantes" — práctica: sí
        "facturacion.comprobantes": {
            summary: "Cómo se usa la pantalla Comprobantes: leer las tarjetas de la cola de CAE, buscar un comprobante con los filtros, abrir su detalle para descargar el PDF, reenviarlo o ir al cobro de origen, y corregir con una nota de crédito con motivo para después emitir la factura correcta. Qué hacer con los pendientes y los fallados.",
            keyPoints: [
                "Arriba: Pendientes de CAE (esperan a ARCA), Fallados (agotaron los reintentos) y El más viejo en cola (si esa fecha se aleja, ARCA no está respondiendo).",
                "En Emitidos buscás por sede, fechas, letra, estado y DNI o CUIT del receptor. El detalle muestra el CAE, el receptor y el total, y desde ahí descargás el PDF, lo reenviás (casilla vacía = la de la ficha) o vas al cobro de origen.",
                "Lo emitido no se borra ni se edita: se corrige con una nota de crédito, con motivo obligatorio, por el total (importe vacío) o parcial. Queda atada a la original.",
                "Cuando ARCA autoriza la nota de crédito, el cobro vuelve a Cobros sin facturar y desde el detalle de la nota se usa «Emitir la factura correcta». Mientras la nota esté pendiente de CAE, no se puede refacturar.",
                "No hay nota de crédito sobre algo sin CAE. Las notas las emiten sólo Administración y Dueños, y quedan en la auditoría con su nombre; el contador consulta y descarga.",
                "Los pendientes se reintentan solos (o con «Reintentar la cola de CAE»). Un «Falló» trae en su detalle el último error de ARCA, que dice qué corregir. «Sin PDF» quiere decir que todavía falta el CAE.",
            ],
            estimatedMin: 9,
            contentVersion: 2,
        },
        // facturacion.emisores — «Emisores fiscales» — roles: admin (Administración), owner (Dueño) — pantalla: "contable.emisores" — práctica: no
        "facturacion.emisores": {
            summary: "Qué es un emisor fiscal: un CUIT que factura en ARCA, con su certificado y sus puntos de venta. Cómo se da de alta, cómo se hace el trámite del certificado en tres pasos (pedido, certificado y prueba), cómo se cargan los puntos de venta por sede, quién factura cuotas y quién kiosko, y cómo se pasa a producción y se renueva. Lo carga el Dueño; Administración lo ve en sólo lectura.",
            keyPoints: [
                "Sin un emisor con certificado, el sistema factura en modo simulado: anda todo, pero los CAE son de prueba y empiezan con nueve.",
                "Se crea con CUIT, nombre, razón social y condición frente al IVA (Responsable Inscripto: A y B; monotributo o exento: C), y siempre se arranca en Homologación, el ambiente de pruebas.",
                "El trámite: generar el pedido (la clave privada queda cifrada en el sistema y no se descarga), hacer los pasos en ARCA, subir el certificado y probar la conexión, que no emite ningún comprobante. El punto de venta tiene que ser para web services.",
                "Cada sede lleva su punto de venta. Con los interruptores se elige el emisor de las cuotas (Gimnasio por defecto) y el del kiosko (Kiosko por defecto), y se puede asignar uno distinto a una sede.",
                "Cuando homologación anda, se duplica a producción y se repiten los tres pasos. Al renovar, el certificado vigente sigue facturando hasta que se carga el nuevo. Un emisor que ya facturó no se elimina: se desactiva.",
                "Un aviso rojo de un CAE otorgado que no se pudo guardar no se reintenta: se le avisa a Deepyze.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // facturacion.exportes — «Exportes contables» — roles: admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "contable.exportes" — práctica: no
        "facturacion.exportes": {
            summary: "Qué trae cada exporte contable del mes (libro IVA Ventas, libro de gastos, cobros por medio y sede, ventas de kiosko) y los dos archivos del formato ARCA. Por qué un comprobante sin CAE queda fuera del libro, y cómo se configura y se reenvía el paquete mensual al contador.",
            keyPoints: [
                "Arriba se elige el mes y la sede; con Todas las sedes sale el club completo.",
                "El libro IVA Ventas sale en CSV o Excel, y en formato ARCA (dos archivos, comprobantes y alícuotas, para importar en el Libro IVA Digital).",
                "Un comprobante sin CAE queda fuera del libro y la pantalla dice cuántos: están esperando a ARCA y entran cuando se autorizan. Antes de mandar el paquete, revisá los pendientes en Comprobantes.",
                "El libro de gastos trae sólo egresos aprobados con su comprobante. En kiosko, las ventas anuladas no cuentan como venta: se informan aparte. Cada descarga queda registrada.",
                "El envío mensual se configura con la casilla del contador y el día (hasta el 28): ese día le llega el paquete del mes anterior con los archivos adjuntos; si uno es muy pesado, va un link de descarga que vence. Sin casilla no sale nada.",
                "Configurar y reenviar es de Administración y Dueños. El contador descarga, pero no cambia la configuración ni manda el paquete.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // facturacion.plataformas — «Liquidación de plataformas (SportClub y Wellhub)» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "contable.convenios" — práctica: no
        "facturacion.plataformas": {
            summary: "Cómo se liquida cada mes lo que deben SportClub y Wellhub: el sistema cuenta los ingresos de sus visitantes registrados por el molinete, los valoriza y arma la pre-liquidación. Cómo se carga lo que informó el convenio, se emite la Factura A, se registra el cobro y se avanza el estado, y qué hacer cuando el convenio informa otro número.",
            keyPoints: [
                "Cada convenio tiene su valor por ingreso con fecha de vigencia. Un valor nuevo no cambia el anterior ni las liquidaciones ya hechas.",
                "La liquidación del mes anterior se genera sola el día configurado, o a mano con «Generar una». El detalle va por sede y por día, y «Ver el respaldo» muestra cada ingreso: día, hora, sede y visitante.",
                "Lo que informa el convenio se carga aparte y la diferencia aparece sola. El registro del club no se toca: es el respaldo para reclamar.",
                "Desde la liquidación se emite la Factura A a nombre del convenio y se registra el cobro (importe, cuenta y número de operación), que queda en Caja atado a la liquidación.",
                "Estados: generada → enviada → informada → cobrada, y no vuelve atrás. Para marcarla informada hay que cargar lo informado; para cobrada, el cobro.",
                "Una liquidación cerrada no se recalcula ni se edita: se corrige con un ajuste con motivo, que queda en la auditoría. Operan Administración y Dueños; coordinación y el contador consultan.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
    },
    questions: [
        // ── facturacion.como-factura ────────────────────────────────────────────
        {
            id: "facturacion.como-factura#1",
            lessonKey: "facturacion.como-factura",
            prompt: "Juana Prueba paga la cuota en efectivo en recepción y te pide la factura en ese momento. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Le explicás que el efectivo no se factura nunca y que sólo lleva el recibo del cobro.",
                },
                {
                    id: "b",
                    text: "En la confirmación del cobro tocás Emitir comprobante.",
                },
                {
                    id: "c",
                    text: "Anulás el cobro y lo volvés a cargar como transferencia, así la factura sale sola.",
                },
                {
                    id: "d",
                    text: "Le decís que vuelva a fin de mes, cuando Administración factura todo el efectivo junto.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el efectivo se factura sólo si el socio la pide, y si la pide en el momento la emitís ahí mismo, en la confirmación del cobro. Si la pide más tarde, la emite Administración desde Cobros sin facturar.",
        },
        {
            id: "facturacion.como-factura#2",
            lessonKey: "facturacion.como-factura",
            prompt: "Un socio que tiene CUIT te pide que la cuota se la factures a su nombre con ese CUIT. ¿Qué factura corresponde?",
            options: [
                {
                    id: "a",
                    text: "Una B, porque toda cuota de un socio es de consumidor final, tenga CUIT o no.",
                },
                {
                    id: "b",
                    text: "Una C, que es la que se usa cuando el receptor tiene CUIT.",
                },
                {
                    id: "c",
                    text: "Una A, que es la de quien tiene CUIT y la pide.",
                },
                {
                    id: "d",
                    text: "Cualquiera de las tres: el sistema no controla la letra antes de emitir.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, la B es para los socios como consumidor final y la A para quien tiene CUIT y la pide (y siempre para SportClub y Wellhub). La C depende del emisor: sólo la emite uno monotributista. Si elegís una letra que no corresponde, el sistema te avisa antes de emitir.",
        },
        {
            id: "facturacion.como-factura#3",
            lessonKey: "facturacion.como-factura",
            prompt: "Cobrás una cuota por transferencia justo cuando ARCA no responde. ¿Qué pasa con el cobro y con la factura?",
            options: [
                {
                    id: "a",
                    text: "El cobro se registra igual y la factura queda Pendiente de CAE: el sistema la reintenta solo.",
                },
                {
                    id: "b",
                    text: "El cobro queda frenado hasta que ARCA vuelva a responder, y esa noche la caja de la sede no se puede cerrar.",
                },
                {
                    id: "c",
                    text: "La factura sale sin CAE y el socio recibe el PDF por mail igual, para no hacerlo esperar.",
                },
                {
                    id: "d",
                    text: "Tenés que entrar a la página de ARCA y hacer esa factura a mano, como se hacía antes.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si ARCA se cae el cobro no se frena nunca y la caja cierra igual. La factura espera como Pendiente de CAE y se reintenta sola; el mail al socio sale recién cuando hay CAE.",
        },
        {
            id: "facturacion.como-factura#4",
            lessonKey: "facturacion.como-factura",
            prompt: "Un socio paga el plan anual en un solo pago y lleva Factura B. Antes de emitir, el sistema te pide el DNI. ¿Por qué y qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Porque la B nunca se puede emitir sin DNI: hay que pedírselo a cada socio en cada cobro.",
                },
                {
                    id: "b",
                    text: "Porque es un error del sistema: cancelás el cobro y lo cobrás en cuotas para que no lo pida.",
                },
                {
                    id: "c",
                    text: "Porque un plan anual siempre va con Factura A: cambiás la letra y cargás el CUIT del socio.",
                },
                {
                    id: "d",
                    text: "Supera el tope de ARCA para consumidor final: confirmás el DNI que trae de la ficha.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si una Factura B supera el tope que fija ARCA para consumidor final, por ejemplo un plan anual en un pago, el sistema pide el DNI del socio. Lo toma de la ficha: sólo tenés que confirmarlo.",
        },
        // ── facturacion.comprobantes ────────────────────────────────────────────
        {
            id: "facturacion.comprobantes#1",
            lessonKey: "facturacion.comprobantes",
            prompt: "A Juana Prueba se le hizo una Factura B y ahora pide Factura A con su CUIT. ¿Cuál es el camino?",
            options: [
                {
                    id: "a",
                    text: "Abrís la B, le cambiás la letra a A y cargás el CUIT: el CAE sigue valiendo para la misma operación.",
                },
                {
                    id: "b",
                    text: "Borrás la B desde la solapa Emitidos y facturás el cobro de nuevo, esta vez como A.",
                },
                {
                    id: "c",
                    text: "Nota de crédito con motivo; cuando tiene CAE, «Emitir la factura correcta» con la A.",
                },
                {
                    id: "d",
                    text: "Emitís una A desde Cobros sin facturar y dejás la B como está, así quedan las dos.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, lo emitido no se borra ni se edita. Se anula con una nota de crédito con motivo, y cuando ARCA la autoriza el cobro vuelve a Cobros sin facturar: desde el detalle de la nota tocás Emitir la factura correcta, elegís la A y cargás el CUIT.",
        },
        {
            id: "facturacion.comprobantes#2",
            lessonKey: "facturacion.comprobantes",
            prompt: "Emitiste la nota de crédito para refacturar a Juana, pero la nota todavía figura Pendiente de CAE. ¿Podés emitir ya la factura correcta?",
            options: [
                {
                    id: "a",
                    text: "No: mientras la nota esté pendiente de CAE no se puede refacturar.",
                },
                {
                    id: "b",
                    text: "Sí: la factura nueva sale y la nota se completa sola cuando ARCA conteste.",
                },
                {
                    id: "c",
                    text: "Sí, pero sólo si la emitís desde la ficha de la socia y no desde Comprobantes.",
                },
                {
                    id: "d",
                    text: "No: tenés que borrar la nota pendiente y hacer otra cuando ARCA vuelva a responder.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el cobro vuelve a Cobros sin facturar recién cuando ARCA autoriza la nota de crédito. Mientras la nota esté pendiente de CAE, no se puede refacturar.",
        },
        {
            id: "facturacion.comprobantes#3",
            lessonKey: "facturacion.comprobantes",
            prompt: "Un socio dice que no le llegó la factura por mail y no te da otra dirección. En el detalle tocás Reenviar por mail. ¿Qué ponés en la casilla?",
            options: [
                {
                    id: "a",
                    text: "El mail del club, para reenviárselo vos después desde tu correo.",
                },
                {
                    id: "b",
                    text: "No se puede dejar vacía: el reenvío exige escribir una casilla cada vez.",
                },
                {
                    id: "c",
                    text: "La casilla del contador, que es quien guarda las copias de las facturas.",
                },
                {
                    id: "d",
                    text: "La dejás vacía: va a la casilla cargada en su ficha.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si dejás la casilla vacía el reenvío va a la que el socio tiene en su ficha; si te da otra, la escribís. Sale con el PDF adjunto.",
        },
        {
            id: "facturacion.comprobantes#4",
            lessonKey: "facturacion.comprobantes",
            prompt: "Un comprobante aparece en rojo, Falló. ¿Qué hacés primero?",
            options: [
                {
                    id: "a",
                    text: "Nada: se reintenta solo como cualquier pendiente hasta que ARCA lo autorice.",
                },
                {
                    id: "b",
                    text: "Abrís su detalle y leés el último error de ARCA, que dice qué corregir.",
                },
                {
                    id: "c",
                    text: "Le hacés una nota de crédito para anularlo y volvés a cobrarle al socio.",
                },
                {
                    id: "d",
                    text: "Lo borrás de la lista para que no quede un comprobante fallado en el libro del mes.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, un Falló ya agotó los reintentos: su detalle trae el último error de ARCA, y eso dice qué corregir. No se le puede hacer nota de crédito porque no tiene CAE, y nada se borra.",
        },
        // ── facturacion.emisores ────────────────────────────────────────────────
        {
            id: "facturacion.emisores#1",
            lessonKey: "facturacion.emisores",
            prompt: "El sistema ya está facturando, pero los CAE de todas las facturas empiezan con nueve. ¿Qué está pasando?",
            options: [
                {
                    id: "a",
                    text: "Es normal: todos los CAE que da ARCA empiezan con nueve.",
                },
                {
                    id: "b",
                    text: "ARCA no está respondiendo y el sistema inventa un número provisorio.",
                },
                {
                    id: "c",
                    text: "Las facturas salieron con la letra equivocada y hay que hacer notas de crédito.",
                },
                {
                    id: "d",
                    text: "No hay emisor con certificado: factura en modo simulado y esos CAE son de prueba.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, sin un emisor con certificado el sistema factura en modo simulado: anda todo, pero los CAE son de prueba y empiezan con nueve. Para facturar de verdad hay que hacer el trámite del certificado.",
        },
        {
            id: "facturacion.emisores#2",
            lessonKey: "facturacion.emisores",
            prompt: "El certificado del emisor de producción está por vencer y generás el pedido de renovación. ¿Qué pasa con la facturación mientras hacés el trámite en ARCA?",
            options: [
                {
                    id: "a",
                    text: "Sigue: el certificado vigente factura hasta que cargues el nuevo.",
                },
                {
                    id: "b",
                    text: "Se corta hasta que cargues el certificado nuevo, así que conviene hacerlo de noche.",
                },
                {
                    id: "c",
                    text: "Pasa sola a homologación y los CAE de esos días quedan de prueba.",
                },
                {
                    id: "d",
                    text: "Hay que duplicar el emisor a producción otra vez y cargar de nuevo los puntos de venta.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, para renovar generás un pedido de renovación y el certificado vigente sigue facturando hasta que cargues el nuevo: no hay corte.",
        },
        {
            id: "facturacion.emisores#3",
            lessonKey: "facturacion.emisores",
            prompt: "Un CUIT que facturó cuotas el año pasado ya no se va a usar más. ¿Qué hacés con su emisor?",
            options: [
                {
                    id: "a",
                    text: "Lo eliminás, así no aparece más en la lista de emisores.",
                },
                {
                    id: "b",
                    text: "Le borrás el certificado y los puntos de venta, y lo dejás activo por si acaso.",
                },
                {
                    id: "c",
                    text: "Lo desactivás, para que sus facturas sigan teniendo dueño.",
                },
                {
                    id: "d",
                    text: "Lo pasás a homologación para que no pueda emitir más.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, un emisor que ya facturó no se puede eliminar: se desactiva, para que sus facturas sigan teniendo dueño.",
        },
        {
            id: "facturacion.emisores#4",
            lessonKey: "facturacion.emisores",
            prompt: "Arriba de la pantalla aparece un aviso rojo: un CAE que ARCA otorgó no se pudo guardar. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Reintentás la emisión de ese comprobante hasta que se guarde bien.",
                },
                {
                    id: "b",
                    text: "No reintentás nada y se lo pasás a Deepyze para que corrija la numeración.",
                },
                {
                    id: "c",
                    text: "Desactivás el emisor y creás otro con el mismo CUIT para empezar de cero.",
                },
                {
                    id: "d",
                    text: "Volvés a Probar conexión, que emite un comprobante de prueba y destraba la cola.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, ante ese aviso no se reintenta nada: el sistema ya frenó ese comprobante para no pedir otro número. Se le pasa a Deepyze para que corrija la numeración.",
        },
        // ── facturacion.exportes ────────────────────────────────────────────────
        {
            id: "facturacion.exportes#1",
            lessonKey: "facturacion.exportes",
            prompt: "El libro IVA Ventas de septiembre dice que tres comprobantes quedaron afuera. ¿Qué significa y qué hacés antes de mandárselo al contador?",
            options: [
                {
                    id: "a",
                    text: "Que se anularon: no hace falta hacer nada, el libro ya está completo así.",
                },
                {
                    id: "b",
                    text: "Todavía no tienen CAE: revisás los pendientes en Comprobantes.",
                },
                {
                    id: "c",
                    text: "Que el sistema los perdió: hay que cargarlos a mano en el formato de ARCA antes de mandarlo.",
                },
                {
                    id: "d",
                    text: "Que son de otra sede: cambiás el filtro a Todas las sedes y aparecen.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, un comprobante sin CAE queda fuera del libro y la pantalla te dice cuántos: no es que no existan, están esperando a ARCA y entran cuando los autorice. Por eso conviene revisar los pendientes antes de mandar el paquete.",
        },
        {
            id: "facturacion.exportes#2",
            lessonKey: "facturacion.exportes",
            prompt: "Al configurar el envío mensual querés que salga el día 30. El sistema no te deja. ¿Por qué?",
            options: [
                {
                    id: "a",
                    text: "Porque el envío sale siempre el día 5 y no se puede cambiar.",
                },
                {
                    id: "b",
                    text: "Porque el día lo elige el contador desde su usuario.",
                },
                {
                    id: "c",
                    text: "Porque a fin de mes ARCA no recibe archivos del Libro IVA Digital.",
                },
                {
                    id: "d",
                    text: "Porque el día llega hasta el 28, para que exista en todos los meses.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el día del envío llega hasta el veintiocho, para que exista en todos los meses. El cinco del ejemplo es sólo una opción.",
        },
        {
            id: "facturacion.exportes#3",
            lessonKey: "facturacion.exportes",
            prompt: "El contador necesita el paquete antes del día configurado, y ese mes uno de los archivos es muy pesado. ¿Qué pasa si tocás Reenviar a mano con la casilla vacía?",
            options: [
                {
                    id: "a",
                    text: "Va a la casilla configurada; el archivo pesado va como link de descarga que vence.",
                },
                {
                    id: "b",
                    text: "No sale: con la casilla vacía el sistema no sabe a quién mandarlo y lo cancela.",
                },
                {
                    id: "c",
                    text: "Sale sin el archivo pesado y el contador lo tiene que pedir en otro mail aparte.",
                },
                {
                    id: "d",
                    text: "Sale recién el día configurado, porque el paquete sólo se manda una vez por mes.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, con la casilla vacía el reenvío va a la configurada. Los archivos van adjuntos, y si alguno es demasiado pesado para el correo, en su lugar va un link de descarga que vence, y el aviso te lo dice.",
        },
        {
            id: "facturacion.exportes#4",
            lessonKey: "facturacion.exportes",
            prompt: "El contador entra a Exportes contables y quiere cambiar la casilla del envío mensual. ¿Puede?",
            options: [
                {
                    id: "a",
                    text: "Sí, porque el envío es para él y es quien mejor sabe adónde tiene que llegar.",
                },
                {
                    id: "b",
                    text: "Sí, pero el cambio rige recién después de que lo apruebe un Dueño.",
                },
                {
                    id: "c",
                    text: "No: descarga, pero la configuración es de Administración y Dueños.",
                },
                {
                    id: "d",
                    text: "No: el contador no puede ni entrar a esta pantalla.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, Administración, Dueños y el contador descargan, pero el envío mensual lo configuran Administración y Dueños. El contador no cambia esta configuración ni manda el paquete.",
        },
        // ── facturacion.plataformas ─────────────────────────────────────────────
        {
            id: "facturacion.plataformas#1",
            lessonKey: "facturacion.plataformas",
            prompt: "SportClub informa 410 ingresos en el mes y el sistema registró 436. ¿Qué se hace?",
            options: [
                {
                    id: "a",
                    text: "Se ajusta el número del club a 410 para que la liquidación cierre con el convenio.",
                },
                {
                    id: "b",
                    text: "Se factura por 410 y la diferencia se da por perdida, porque manda lo que informa el convenio.",
                },
                {
                    id: "c",
                    text: "Se carga lo informado aparte y se reclama la diferencia con el respaldo del club.",
                },
                {
                    id: "d",
                    text: "Se borra la liquidación y se genera otra cuando SportClub mande el número corregido.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, lo informado se guarda aparte y el registro del club no se toca. La diferencia queda marcada, y el detalle por día, hora y visitante es lo que mandás para reclamar.",
        },
        {
            id: "facturacion.plataformas#2",
            lessonKey: "facturacion.plataformas",
            prompt: "Wellhub sube el valor por ingreso desde el 1 de octubre. ¿Qué pasa con la liquidación de septiembre, que ya estaba hecha?",
            options: [
                {
                    id: "a",
                    text: "No cambia: el valor nuevo rige desde su fecha y lo ya liquidado queda intacto.",
                },
                {
                    id: "b",
                    text: "Se recalcula sola con el valor nuevo, porque el sistema siempre usa el último.",
                },
                {
                    id: "c",
                    text: "Hay que generarla de nuevo para que tome el valor nuevo.",
                },
                {
                    id: "d",
                    text: "Queda bloqueada hasta que Administración confirme con qué valor se liquida.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, con Nuevo valor unitario cargás el monto y desde qué día rige. El valor anterior queda intacto y las liquidaciones ya hechas no cambian.",
        },
        {
            id: "facturacion.plataformas#3",
            lessonKey: "facturacion.plataformas",
            prompt: "Una liquidación ya cerrada tenía un error de conteo. ¿Cómo se corrige?",
            options: [
                {
                    id: "a",
                    text: "Se edita el número de ingresos y se vuelve a emitir la Factura A.",
                },
                {
                    id: "b",
                    text: "Se vuelve el estado a generada y se recalcula desde el molinete.",
                },
                {
                    id: "c",
                    text: "No se puede corregir de ninguna forma: el error queda como está.",
                },
                {
                    id: "d",
                    text: "Con un ajuste con motivo (puede ser negativo), que queda en la auditoría.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, una liquidación cerrada no se recalcula ni se edita, y el estado no vuelve para atrás. La corrección es un ajuste, que puede ser negativo, con su motivo, y queda en la auditoría.",
        },
        {
            id: "facturacion.plataformas#4",
            lessonKey: "facturacion.plataformas",
            prompt: "Querés pasar la liquidación de SportClub a «cobrada», pero el sistema no te deja. ¿Qué falta?",
            options: [
                {
                    id: "a",
                    text: "Que la apruebe el contador, que es quien controla las liquidaciones.",
                },
                {
                    id: "b",
                    text: "Registrar el cobro: importe, cuenta donde entró y número de operación.",
                },
                {
                    id: "c",
                    text: "Que pase un mes desde que se emitió la Factura A, para que el banco acredite.",
                },
                {
                    id: "d",
                    text: "Volver a generarla, porque las cobradas se arman de cero con el valor vigente.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, para marcarla cobrada tenés que haber registrado el cobro: el importe, la cuenta bancaria donde entró y el número de operación. El cobro queda en Caja, atado a la liquidación.",
        },
    ],
};
//# sourceMappingURL=facturacion.js.map